import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private isCollapsed = signal(false);
  private isOpenMobile = signal(false);

  getCollapsed() {
    return this.isCollapsed.asReadonly();
  }

  getIsOpenMobile() {
    return this.isOpenMobile.asReadonly();
  }

  isExpanded(): boolean {
    return !this.isCollapsed();
  }

  collapse() {
    this.isCollapsed.set(true);
  }

  expand() {
    this.isCollapsed.set(false);
  }

  toggle() {
    this.isCollapsed.update((current) => !current);
  }

  openMobile() {
    this.isOpenMobile.set(true);
  }

  closeMobile() {
    this.isOpenMobile.set(false);
  }

  toggleMobile() {
    this.isOpenMobile.update((current) => !current);
  }
}
